import { Directive, ElementRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BusyService } from '../services/busy.service';

@Directive({
  standalone: false,
  selector: '[disableDuringRequest]'
})
export class DisableButtonDuringRequestDirective implements OnDestroy {
  private subscription: Subscription;

  constructor(private busyService: BusyService, private el: ElementRef) {
    this.subscription = this.busyService.onBusyStatusChanged.subscribe(isBusy => {
      if (isBusy) {
        this.el.nativeElement.classList.add('disabled', 'disabled--grayed');
      } else {
        this.el.nativeElement.classList.remove('disabled', 'disabled--grayed');
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}